module.exports = __webpack_public_path__ + "zvetseni-prsou_53_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-prsou_53_before_tn.jpg
// module id = 1816
// module chunks = 0